module.exports = __webpack_public_path__ + "fonts/6e104aff429df8b4479fe624a2e6ffdc.svg";